exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".lang[data-v-0a88a7da]{cursor:pointer;box-sizing:border-box}.lang .checked[data-v-0a88a7da]{color:#0a64fa}.gou[data-v-0a88a7da]{width:12px;height:9px;position:absolute;top:7px;left:-20px}.u-li[data-v-0a88a7da]{position:relative;margin-left:2px}", ""]);

// exports
